define('models/user/register/bulk_register',[ 'backbone' ], function(Backbone){

    var Register = Backbone.Model.extend({

        urlRoot: function(){            
            
            if(this.instanceURL){
                return this.instanceURL;
            } else {
                return pf.userURL + '/SimpleRegistration';
            }

        },

        initialize: function(options){
            options = options || {};

            this.instanceURL = options.instanceURL;

            this.ATPP = options.ATPP;
            this.CGID = options.CGID;
            this.CID = options.CID;
            this.CN = options.CN;
            this.DOB = options.DOB;
            this.EG = options.EG;
            this.EPID = options.EPID;
            this.FN = options.FN;
            this.HP = options.HP;
            this.HVR = options.HVR;
            this.ITP = options.ITP;
            this.LN = options.LN;
            this.OIWP = options.OIWP;
            this.OPT = options.OPT;
            this.P = options.P;
            this.S = options.S;
            this.SOC = options.SOC;
            this.UG = options.UG;
            this.Z = options.Z;
            this.CP = options.CP;
            this.AGUID = options.AGUID;

            this.E = options.Email;
            this.MID = options.MemberID;
            this.NP = options.Password;
            this.OIWP = options.OIWP;
            this.OP = options.Optional;
            this.OPT = options.BCBSLAOptional;
            this.U = options.Unsubscribe;

            this.SPID = options.SPID;
            this.CLID = options.CLID;
            this.PID = options.PID;
            this.DP = options.DP;
            this.ACCTGUID = options.ACCTGUID;
            this.CUID = options.CUID;
        },

        save: function(attributes, options){
            options = options || {};

            attributes = attributes || {};

            var data = {};

            data.ATPP = this.attributes.ATPP;
            data.CGID = this.attributes.CGID;
            data.CID = this.attributes.CID;
            data.CN = this.attributes.CN;
            data.DOB = this.attributes.DOB;
            data.EG = this.attributes.EG;
            data.EPID = this.attributes.EPID;
            data.FN = this.attributes.FN;
            data.HP = this.attributes.HP;
            data.HVR = this.attributes.HVR;
            data.ITP = this.attributes.ITP;
            data.LN = this.attributes.LN;
            data.OIWP = this.attributes.OIWP;
            data.OPT = this.attributes.OPT;
            data.P = this.attributes.P;
            data.S = this.attributes.S;
            data.SOC = this.attributes.SOC;
            data.UG = this.attributes.UG;
            data.Z = this.attributes.Z;
            data.CP = this.attributes.CP;
            data.AGUID = this.attributes.AGUID;

            data.E = this.E;
            data.MID = this.MID;
            data.NP = this.NP;
            data.OIWP = this.OIWP;
            data.U = this.U;
            data.OP = this.OP;
            data.OPT = this.OPT;
            data.U = this.U;

            data.SPID = this.attributes.SPID;
            data.CLID = this.attributes.CLID;
            data.PID = this.attributes.PID;
            data.DP = this.attributes.DP;
            data.ACCTGUID = this.attributes.ACCTGUID;
            data.CUID = this.attributes.CUID;
            
            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return Register;
});

